import { HTMLAttributes } from 'react'
import lowerCase from 'lodash/lowerCase'

import Container from '@/components/base/Container'
import Form from '@/components/base/Form'
import Grid from '@/components/base/Grid'
import SVGIcon from '@/components/base/SVGIcon'
import Typography from '@/components/base/Typography'
import Spacer from '@/components/sections/Spacer'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'
import { WPPageData } from '@/types'

export type ContactProps = HTMLAttributes<HTMLElement> & {
  pageData?: WPPageData
}

const Contact = ({ pageData }: ContactProps) => {
  const { menu } = useStore()
  return (
    <>
      <Container className="pt-[16rem]">
        <Grid className="gap-y-gutter">
          <div
            className={cn([
              'col-span-4',
              'md:col-span-6',
              'lg:col-span-4 lg:col-start-2'
            ])}
          >
            <div className="flex h-full flex-col gap-[2rem]">
              <Typography
                variant="h2"
                component="h1"
                className="hidden lg:block"
              >
                {pageData?.acf?.title_sx}
              </Typography>
              <Typography variant="body" className="hidden lg:block">
                {pageData?.acf?.text_sx}
              </Typography>
              {pageData?.acf?.contacts_block &&
              pageData.acf.contacts_block.length > 0 ? (
                <div className="mt-auto flex flex-col gap-[1.6rem]">
                  <Typography variant="body-strong">
                    {pageData.acf.contacts_block[0].title}
                  </Typography>
                  <Typography variant="body">
                    {pageData.acf.contacts_block[0].text}
                  </Typography>
                </div>
              ) : null}
            </div>
          </div>
          <div
            className={cn([
              '-order-1 col-span-4',
              'md:col-span-6',
              'lg:order-1 lg:col-span-5 lg:col-start-7'
            ])}
          >
            <div className="flex flex-col gap-[2rem]">
              <Typography variant="h2" component="h2" className="lg:hidden">
                {pageData?.acf?.title_sx}
              </Typography>
              <Typography variant="label" className="font-bold">
                {pageData?.acf?.title_dx}
              </Typography>
              <Form
                form_id={pageData?.acf?.form_id}
                fields={pageData?.acf?.form?.fields}
                submit={pageData?.acf?.form?.submit}
              />
            </div>
          </div>
        </Grid>
        <Spacer variant="md" theme="transparent" />
      </Container>
      {pageData?.acf?.contacts_block &&
      pageData.acf.contacts_block.length > 1 ? (
        <Container className="bg-dark-200">
          <Grid className="py-[6.4rem]">
            <div className="col-span-4 flex flex-col gap-[3rem] md:col-span-6 lg:col-span-10 lg:col-start-2 lg:flex-row">
              {pageData.acf.contacts_block[1].title ||
              pageData.acf.contacts_block[1].text ? (
                <div className="flex flex-[1_0_0] flex-col gap-[1.6rem]">
                  <Typography variant="body-strong">
                    {pageData.acf.contacts_block[1].title}
                  </Typography>
                  <Typography variant="body">
                    {pageData.acf.contacts_block[1].text}
                  </Typography>
                </div>
              ) : null}
              {pageData.acf.contacts_block[2].title ||
              pageData.acf.contacts_block[2].text ? (
                <div className="flex flex-[1_0_0] flex-col gap-[1.6rem]">
                  <Typography variant="body-strong">
                    {pageData.acf.contacts_block[2].title}
                  </Typography>
                  <Typography variant="body">
                    {pageData.acf.contacts_block[2].text}
                  </Typography>
                </div>
              ) : null}
              {pageData.acf.contacts_block[3].title ||
              pageData.acf.contacts_block[3].text ? (
                <div className="flex flex-[1_0_0] flex-col gap-[1.6rem]">
                  <Typography variant="body-strong">
                    {pageData.acf.contacts_block[3].title}
                  </Typography>
                  <Typography variant="body">
                    {pageData.acf.contacts_block[3].text}
                  </Typography>
                </div>
              ) : null}
            </div>
          </Grid>
        </Container>
      ) : null}
      <Spacer variant="md" theme="transparent" />
      {menu?.social_menu?.menu && menu.social_menu.menu.length > 0 ? (
        <Container>
          <Grid>
            <div className="col-span-4 md:col-span-6 lg:col-span-10 lg:col-start-2">
              <ul className="flex gap-[1.6rem]">
                {menu.social_menu.menu.map((item, index) => (
                  <li key={index}>
                    <a
                      href={item.url}
                      target={item.target}
                      className={cn([
                        'flex size-[4.4rem] items-center justify-center rounded-full border border-dark-200',
                        'group'
                      ])}
                    >
                      <SVGIcon
                        symbol={`${lowerCase(item.title)}-circle-icon`}
                        className={cn([
                          'h-full w-full shrink-0 text-dark-500',
                          'transition-colors duration-300 ease-out-cubic group-hover:text-dark-900'
                        ])}
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Grid>
          <Spacer variant="md" theme="transparent" />
        </Container>
      ) : null}
    </>
  )
}

export default Contact
